module.exports = __webpack_public_path__ + "img/bg-1.1d1704c6.png";